<template>
  <div 
    v-if="active" 
    id="login-first-modal" 
    :class="{'is-active': active}"
    class="ec-modal ec-login-first-modal"
    @click.self="closeModal">
    <div class="ec-modal-main is-loading animated fadeIn blue-border">
      <a 
        href="#" 
        class="close-icon modal-close"
        @click.stop.prevent="closeModal" />
      <div class="ec-modal-headline">{{ $t('modals.login.title') }}</div>
      <div class="ec-modal-text">{{ $t('modals.login.msg') }}</div>
      <div class="ec-modal-btn-wrapper">
        <button 
          id="ec-modal-variable-cancel" 
          class="ec-modal-btn-cancel btn is-grey modal-close"
          @click="closeModal">{{ $t('modals.login.cancel') }}
        </button>
        <button 
          id="ec-modal-variable-ok" 
          class="ec-modal-btn-ok btn is-blue" 
          @click="ok">{{ $t('modals.login.ok') }}
        </button>
      </div>
      <div 
        v-show="loading" 
        class="ec-modal-loader"/>
    </div>
  </div>
</template>
<script>
    import {startsWith} from 'lodash'
    import { redirect } from '../utility'
    import Modal from './Modal.mixin.vue'    

    export default {
        mixins: [Modal],
        data: function () {
            return {
                loading: false,
                setCookie: null
            }
        },
        watch: {},
        created() {
            this.$event.$on('login-first', (payload) => {
                if (startsWith(payload, 'autocall')) {
                     this.setCookie = payload
                }

                this.active = true
                this.$store.modalOpen = true
            })
        },
        methods: {
            ok: function () {
                if (this.setCookie) {
                    this.$cookie.set(this.setCookie, 1, 1)
                }

                redirect(eventsuiteLoginService)
            }
        },
    }
</script>